import 'es6-promise/auto';
import 'es6-shim';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VModal from 'vue-js-modal';
import LoadScript from 'vue-plugin-load-script';
import i18n from './i18n';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(VModal, { dialog: true });
Vue.use(LoadScript);

new Vue({
  render: h => h(App),
  router,
  store,
  i18n,
}).$mount('#app');
